import { Injectable } from "@angular/core";
import { Nilable } from "@shared/utils";

@Injectable({
    providedIn: "root"
})
export class ErrorService {
    private error: Nilable<any>;

    constructor() { }

    public hayError(): boolean {
        return this.error != null;
    }

    public obtenerError<T>(): T {
        return this.error as T;
    }

    public guardarError<T>(error: T): void {
        this.error = error;
    }
}
